import { attr, html, TNode, Value } from '@tempots/dom'

export type FeatureCardOptions = {
  iconUrl: Value<string>
  title: TNode
  description: TNode
}

export function FeatureCard({
  iconUrl,
  title,
  description,
}: FeatureCardOptions) {
  return html.div(
    attr.class(
      'flex flex-col gap-2 p-4 sm:p-5 md:p-6 rounded-lg bg-white w-full sm:w-64 md:w-72 shadow-lg border border-gray-200'
    ),
    html.div(
      attr.class(
        'flex items-center justify-center pb-2 rounded-lg w-10 h-10 sm:w-12 sm:h-12'
      ),
      html.img(attr.src(iconUrl), attr.class('w-full'))
    ),
    html.div(attr.class('font-bold text-sm sm:text-base'), title),
    html.div(attr.class('text-sm sm:text-base leading-tight'), description)
  )
}
